<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('regiao') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('vendas') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: `${$route.meta.abrev}-regiao-list` })">{{
                                        $t('regioes')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id
                                            ? $route.params.id + ' - ' + regiao.descricao
                                            : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: `${$route.meta.abrev}-regiao-list` })"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                (!usuarioIntegracao && !isUpdate && permissao.create) ||
                                (!usuarioIntegracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-6">
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="regiao.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!regiao.descricao"
                                uppercase
                                title="descricao"
                            />
                        </div>
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(2)"
                                ref="empresaSelect"
                                :searchable="false"
                                :options="empresas"
                                v-model="empresa"
                                class="no-clear"
                                title="empresa"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(3)"
                                v-model="regiao.reajustecif"
                                placeholder="placeholder-preencha"
                                :msg="msgPorcentagemInvalida"
                                :invalid="invalidPorcentagemCif"
                                :onBlurFunction="validatePorcCif"
                                :maxlength="6"
                                ref="reajusteCifInput"
                                validchars="0123456789."
                                title="reajuste-por-cif"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(4)"
                                v-model="regiao.reajustefob"
                                placeholder="placeholder-preencha"
                                :msg="msgPorcentagemInvalida"
                                :invalid="invalidPorcentagemFob"
                                :onBlurFunction="validatePorcFob"
                                :maxlength="6"
                                ref="reajusteFobInput"
                                validchars="0123456789."
                                title="reajuste-por-fob"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(5)"
                                v-model="regiao.valorminimofob"
                                placeholder="placeholder-preencha"
                                :maxlength="3"
                                ref="valorMinimoFobInput"
                                validchars="0123456789."
                                title="valor-minimo-fob"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(6)"
                                v-model="regiao.valorminimocif"
                                placeholder="placeholder-preencha"
                                ref="valorMinimoCifInput"
                                validchars="0123456789."
                                title="valor-minimo-cif"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(7)"
                                v-model="regiao.ticketmedio"
                                placeholder="placeholder-preencha"
                                ref="ticketMedioInput"
                                validchars="0123456789."
                                title="ticket-medio"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                :id="generateId(8)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="regiao.idregiao == null"
                                title="situacao"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**************************************************************************************************************************************************
ESTA TELA/COMPONENTE NÃO É MAIS UTILIZADO (ESTÁ DEPRECIADO). AS TELAS/COMPONENTES DE REGIÃO CORRETAS SÃO RELACIONADAS A CATEGORIA DE PROMOTOR
***************************************************************************************************************************************************/
import RegiaoService from '@/services/RegiaoService';
import TransportadoraValidation from '@/services/validations/vendas/TransportadoraValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes('REGIAO'),
            service: new RegiaoService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: new TransportadoraValidation(this.msgs),
            regiao: {
                idregiao: null,
                idregiaoerp: null,
                idempresa: null,
                descricao: null,
                situacao: null,
                reajustecif: null,
                reajustefob: null,
                valorminimofob: null,
                valorminimocif: null,
                ticketmedio: null,
            },
            isUpdate: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },
            empresas: this.$store.state.user.empresas.map((e) => ({ id: e.id, label: e.nome })),
            empresa: {
                id: this.$store.state.user.empresas[0].id,
                label: this.$store.state.user.empresas[0].nome,
            },
            msgPorcentagemInvalida: 'porcentagem-invalida',
            invalidPorcentagemCif: false,
            invalidPorcentagemFob: false,
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;
        this.permissao = this.hasPermissionAccess('vendas', 'clientes', 'ven-regiao');
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'regiao' },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
                this.isUpdate = true;
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.regiao = value.content;
                    this.situacao = this.situacoes[this.regiao.situacao];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        save() {
            this.isLoading = true;

            if (this.validation.validate(this.transportadora, this.$refs)) {
                let transportadoraTemp = Object.assign({}, this.transportadora);
                transportadoraTemp = this.mapTosave(transportadoraTemp);
                transportadoraTemp.situacao = this.situacao.id;
                transportadoraTemp.cnpj = this.transportadora.cnpj;

                this.invalidIcon = false;
                this.isSaving = true;
                this.service
                    .save(transportadoraTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'msg-regiao-salva';
                            if (this.transportadora.idtransportadora != null) {
                                msg = 'msg-regiao-editada';
                            }
                            this.msgs.push(new Message('success', msg, true));
                            this.redirectToList();
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        mapOnSave(value) {
            return {
                id: value.id,
                descricao: value.nome,
            };
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: `${this.$route.meta.abrev}-regiao-list`,
                });
            }, 1000);
        },
        validatePorcCif() {
            this.invalidPorcentagemCif = !this.validatePorcentagem(this.regiao.reajustecif);
        },
        validatePorcFob() {
            this.invalidPorcentagemFob = !this.validatePorcentagem(this.regiao.reajustefob);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
